import type { CSSProperties } from 'react';
import { createSeededRng } from '../../domain/seededRandom.js';
import type { WorldSnapshot } from '../../domain/types.js';

const PALETTES: Array<[string, string, string]> = [
  ['#0b1d3a', '#1a4a6b', '#ffd166'],
  ['#14161f', '#2a3a5c', '#06d6a0'],
  ['#1a0f2e', '#3d2c5a', '#4cc9f0'],
  ['#0f1a14', '#2d4a3a', '#f72585'],
];

/** Deterministic CSS backdrop behind the static aquarium photo. */
export function aquariumFallbackStyle(snapshot: WorldSnapshot): CSSProperties {
  const rng = createSeededRng(`${snapshot.worldId}:aquarium-bg`);
  const [deep, mid, accent] = PALETTES[Math.floor(rng() * PALETTES.length)]!;
  const angle = Math.floor(rng() * 360);
  return {
    background: `linear-gradient(${angle}deg, ${deep} 0%, ${mid} 45%, ${deep} 100%)`,
    boxShadow: `inset 0 0 120px ${accent}22`,
  };
}

export function locationDisplayName(snapshot: WorldSnapshot): string {
  const name = snapshot.location.name?.trim();
  return name || 'Unnamed location';
}

export function periodDisplayLabel(snapshot: WorldSnapshot): string {
  const tp = snapshot.timePeriod;
  return tp.present?.trim() || tp.period?.trim() || 'Unknown period';
}

/** The location title's period. "Present day" means the browser's current date. */
export function isPresentDayPeriod(period: { present?: string; period?: string } | null | undefined): boolean {
  const value = (period?.present || period?.period || '').trim().toLowerCase();
  return value === 'present day' || value === 'present' || value === 'today' || value === 'modern day';
}
